export default __webpack_public_path__ + "static/media/Algorand (ALGO) Light.ff1605dd.svg";